<template lang="slm">
section.greyback
  .container
    .columns.is-multiline
      .column (
        v-for="(link, index) in links"
        :class="isEven(index) ? 'is-6-tablet is-5-desktop is-offset-1-desktop is-3-widescreen is-offset-0-widescreen' : 'is-6-tablet is-5-desktop is-3-widescreen'"
        )
        link-card  :link="link" :key="link.id"

</template>

<script>
import LinkCard from '@/components/LinkCard'

export default {
  components: {
    'link-card': LinkCard
  },
  data () {
    return {
    }
  },
  props: ['links'],
  methods: {
    isEven (n) { return n % 2 === 0 }
  }
}
</script>

<style lang="css">

</style>



// WEBPACK FOOTER //
// src/components/LinksBlock.vue